// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const VideoPlayerContract = contract({
  name: "VideoPlayer",
  description: "HTML5 video wrapped in the shared media surface. Controls-on for a standard player, controls-off (+ autoplay/muted/loop) for hero / background video. Prefer Rive for anything interactive, Three Scene for shader backgrounds.",
  import: "@gradeui/ui",
  aliases: ["video","mp4","movie","webm","clip","video view","av player","react native video","video element"],
  composesWith: ["MediaSurface (internal)","Card (wrap for thumbnail grids)"],
  styleDefaults: {"VideoPlayer":"w-full h-full"},
  props: {
  "src": {
      schema: z.string(),
      design: "content",
      description: "video URL",
  },
  "controls": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "show native controls; false for chromeless hero/background video",
      default: true,
  },
  "autoPlay": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "forces muted=true (browser restriction)",
      default: false,
  },
  "loop": {
      schema: z.boolean().optional(),
      design: "knob",
      default: false,
  },
  "muted": {
      schema: z.boolean().optional(),
      design: "knob",
      default: false,
  },
  "pauseOffscreen": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "pause when scrolled out of viewport",
      default: true,
  },
  "aspect": {
      schema: z.enum(["video", "square", "portrait", "wide", "auto"]).optional(),
      design: "knob",
      default: "video",
  },
  "radius": {
      schema: z.enum(["none", "sm", "md", "lg", "xl"]).optional(),
      design: "knob",
      description: "driven by `--gds-media-radius`",
      default: "lg",
  },
  "objectFit": {
      schema: z.enum(["cover", "contain", "fill"]).optional(),
      design: "knob",
      default: "cover",
  },
  "poster": {
      schema: z.string().optional(),
      design: "content",
      description: "image shown before playback. Always rendered as a `loading=\"lazy\"` `<img>` overlay (not the native `poster` attribute, which fetches eagerly).",
  },
  "playbackRate": {
      schema: z.number().optional(),
      design: "knob",
  },
  },
});
